import { DialogTitle, IconButton, styled } from "@mui/material";

export const AppModalTitle = styled(DialogTitle, {
  label: "app-modal-dialog-title",
})(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: "10px 20px",
  textTransform: 'uppercase',
}));

export const IconButtonClose = styled(IconButton, {
  label: "app-modal-dialog-iconButtonClose",
})(({ theme }) => ({
  
  "svg":{fontSize: 18.5,}
}));